export enum ImageSizesEnum {
	XL = 'XL',
	L = 'L',
	M = 'M',
	S = 'S',
	XS = 'XS',
}
